import { useEffect, useState } from "react";
import { Card, Table, Button, Modal, Form, Input, message } from "antd";
import {
  getNotificationTemplates,
  updateNotificationTemplate,
} from "../../constants/API/API";

const NotificationTemplate = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [form] = Form.useForm();

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const res = await getNotificationTemplates();
      console.log("API RESPONSE:", res);

      setTemplates(Array.isArray(res) ? res : []);
    } catch (error) {
      message.error("Failed to load templates");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      await updateNotificationTemplate(editingTemplate._id, {
        title: values.title,
        content: values.content,
      });

      message.success("Template updated successfully");
      setEditingTemplate(null);
      form.resetFields();
      fetchTemplates();
    } catch (error) {
      message.error("Failed to update template");
    }
  };

  const columns = [
    { title: "Title", dataIndex: "title" },
    { title: "Identifier", dataIndex: "slug" },
    { title: "Content", dataIndex: "content", ellipsis: true },
    {
      title: "Action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => {
            setEditingTemplate(record);
            form.setFieldsValue({
              title: record.title,
              content: record.content,
            });
          }}
        >
          Edit
        </Button>
      ),
    },
  ];

  return (
    <Card title="Notification Template Manager">
      <Table
        dataSource={templates}
        columns={columns}
        rowKey="_id"
        loading={loading}
        pagination={false}
      />

      <Modal
        title={`Edit Template - ${editingTemplate?.title}`}
        open={!!editingTemplate}
        onCancel={() => {
          setEditingTemplate(null);
          form.resetFields();
        }}
        onOk={handleSave}
        okText="Save"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="title"
            label="Template Title"
            rules={[{ required: true, message: "Please enter title" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="content"
            label="Notification Content"
            rules={[{ required: true, message: "Please enter content" }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>

          <p>
            <b>Variables:</b>{" "}
            {editingTemplate?.variables?.map((v) => `{{${v}}}`).join(", ") ||
              "None"}
          </p>
        </Form>
      </Modal>
    </Card>
  );
};

export default NotificationTemplate;
